import React from "react";

import { useMutation } from "react-query-legacy";

import { Form, message } from "antd";
import { Store } from "antd/lib/form/interface";

import { BillingEngineService } from "services";

import ServiceFormWrapper from "../_common/ServiceFormWrapper";
import ServiceRate from "../_common/ServiceRate";
import { useRateCardContext, useEditServiceContext } from "../contextProviders";
import { SuppliesContextProvider, useSuppliesContext } from "../contextProviders/SuppliesContextProvider";
import { useCurrentVersion } from "../hooks";
import { deserializedSuppliesFormSchema } from "./formSchema";
import MarkupSection from "./MarkupSection";
import SuppliesSection from "./SuppliesSection";

const SuppliesRates: React.FC = () => {
  const { setAllowEditing } = useEditServiceContext();

  // Current rate card
  const { rateCard, status, activeZone, activeZonesCities, dispatch, isLoadingZones } = useRateCardContext();

  const { consumableMaterials: initialSupplies } = useSuppliesContext();

  const [form] = Form.useForm();

  const initialValues = {
    supplies: initialSupplies,
  };

  // Creates version
  const [createVersion, { status: creatingVersionStatus }] = useMutation(
    BillingEngineService.updateZoneRateCardVersion,
    {
      onSuccess: (data) => {
        dispatch({
          type: "CREATE_VERSION",
          version: data,
        });
      },
    }
  );

  /**
   * Returns get version params
   * if false query will not run
   */
  const { data: currentVersion, status: currentVersionLoadingStatus } = useCurrentVersion(activeZone);

  const initialFormValues = React.useMemo(() => {
    return deserializedSuppliesFormSchema.cast(currentVersion?.data || initialValues);
  }, [initialValues, currentVersion]);

  /**
   * Handle form submition
   * @param values Form Values
   */
  const onFinish = (values: Store) => {
    if (activeZone && values) {
      createVersion({
        rateCardId: activeZone.rateCardId,
        rateCardZoneId: activeZone.id,
        version: values,
      })
        .then(() => {
          message.success("New version created.");
        })
        .finally(() => {
          setAllowEditing(false);
        });
    }
  };

  const onReset = () => {
    form.resetFields();
    form.setFieldsValue(initialFormValues);
  };

  // /**
  //  * Effect that handle form values populations
  //  * whenever one of dependencies changes
  //  */
  React.useEffect(() => {
    form.resetFields();
    form.setFieldsValue(initialFormValues);
  }, [initialFormValues, form]);

  return (
    <ServiceRate serviceName="Supplies">
      <ServiceFormWrapper
        onSave={() => {
          form.submit();
        }}
        onCancel={onReset}
        loading={
          currentVersionLoadingStatus === "loading" ||
          creatingVersionStatus === "loading" ||
          status === "loading" ||
          isLoadingZones
        }
        title="Supplies"
      >
        {status === "success" && rateCard && <MarkupSection form={form} />}
        {activeZonesCities.length > 0 && (
          <Form
            key={activeZonesCities.length}
            hideRequiredMark
            name="supplies"
            form={form}
            onFinish={onFinish}
            initialValues={initialFormValues}
          >
            <SuppliesSection form={form} />
          </Form>
        )}
      </ServiceFormWrapper>
    </ServiceRate>
  );
};

function SuppliesRatesContainer() {
  return (
    <SuppliesContextProvider>
      <SuppliesRates />
    </SuppliesContextProvider>
  );
}

export default SuppliesRatesContainer;
